class collectionFaq extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new Swiper('.faq-description-swiper',{
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        loop:false,
        resistanceRatio : 0,
        navigation: {
          nextEl: '.faq-description-swiper .swiper-button-next',
          prevEl: '.faq-description-swiper .swiper-button-prev',
        },
    })
  }
}
customElements.define('collection-faq', collectionFaq);